import React from 'react'
import { startCase } from 'lodash-es'
import { Box } from '@node-space/ui-components'
import { sentenceCase } from 'utils/utils'

interface ErrorItemProps {
  subTitle: string
  errors: string[]
  displaySubTitle: boolean
}

export const ErrorItem = ({ subTitle, errors, displaySubTitle }: ErrorItemProps) => (
  <Box key={subTitle} paddingB={12}>
    {displaySubTitle && (
      <Box paddingB={4}>
        <span className="text-body-regular text-inherit">{sentenceCase(startCase(subTitle))}</span>
      </Box>
    )}
    <ul className="text-body-regular-small text-inherit list-disc list-outside pl-3">
      {errors?.map((error, index) => (
        <li key={`${subTitle}-${index}`}>{error}</li>
      ))}
    </ul>
  </Box>
)
